import React,
{
  createContext,
  useState,
  useEffect,
} from "react";

import { db } from "../firebase";

import {
  collection,
  addDoc,
  getDocs,
} from "firebase/firestore";

import { getShopId } from "../utils/shop";

export const CustomerContext =
  createContext();

export const CustomerProvider =
({ children }) => {

  const [customers,
setCustomers] = useState([
  {
    name: "Walk-in Customer",
    phone: "0000000000",
  },
]);

  useEffect(() => {

  const loadCustomers =
    async () => {

      try {

        const shopId =
          getShopId();

        const snapshot =
          await getDocs(

            collection(
              db,
              "shops",
              shopId,
              "customers"
            )

          );

        const data =
          snapshot.docs.map(
            doc => ({
              id: doc.id,
              ...doc.data(),
            })
          );

        setCustomers([
          {
            name:
              "Walk-in Customer",
            phone:
              "0000000000",
          },
          ...data,
        ]);

      } catch (error) {

        console.error(
          error
        );

      }

    };

  loadCustomers();

}, []);

  const addCustomer =
async (customer) => {

  try {

    const shopId =
      getShopId();

    const docRef =
      await addDoc(

        collection(
          db,
          "shops",
          shopId,
          "customers"
        ),

        customer

      );

    setCustomers(
      (prev) => [

        ...prev,

        {
          id:
            docRef.id,
          ...customer,
        },

      ]
    );

  } catch (error) {

    console.error(
      error
    );

    alert(
      "Failed to save customer"
    );

  }

};

  return (

    <CustomerContext.Provider
      value={{

        customers,

        setCustomers,

        addCustomer,

      }}
    >

      {children}

    </CustomerContext.Provider>

  );
};